import React from 'react'

// styles

import './HeaderPanel.less'

import classNames from 'classnames'

const COMPONENT_CLASS = 'nmc-header-panel'

export default class HeaderPanel extends React.Component {

  render () {
    const {className} = this.props

    const legendClassNames = classNames(COMPONENT_CLASS, className)

    return (
      <div className={classNames(legendClassNames)}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/HeaderPanel/index.js